export enum ComponentType {
  TextFieldInput = 'TextFieldInput',
  SelectItemInput = 'SelectItemInput',
  RadioButtonInput = 'RadioButtonInput',
  FixedText = 'FixedText',
  KeyboardDateInput = 'KeyboardDateInput',
  EntryDateInput = 'EntryDateInput',
  SelectDateInput = 'SelectDateInput',
  EmailInput = 'EmailInput',
  KanaNameAutoCompleteInput = 'KanaNameAutoCompleteInput'
}
